import type { Registry as Services } from '@ember/service';
import { tKey } from 'ember-intl';
import timestampDiffInDays from 'lumen/utils/overview-dashboard/timestamp-diff-in-days';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function formatLastUpdatedTimestamp(
  intl: Services['intl'],
  lastUpdatedTimestamp: string,
) {
  let formattedLastUpdatedTimestamp = null;

  if (lastUpdatedTimestamp) {
    const diffInDays = timestampDiffInDays(lastUpdatedTimestamp);

    if (diffInDays === 0) {
      formattedLastUpdatedTimestamp = intl.t(
        tKey('overview_dashboard.tooltip.out_of_sync.updated_today'),
      );
    } else {
      formattedLastUpdatedTimestamp = intl.t(
        tKey('overview_dashboard.tooltip.out_of_sync.days_ago'),
        { count: diffInDays },
      );
    }
  }

  return formattedLastUpdatedTimestamp;
}
